import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { saveAs } from 'file-saver';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-uploadfile',
  templateUrl: './uploadfile.component.html',
  styleUrls: ['./uploadfile.component.scss'],
})
export class UploadfileComponent  implements OnInit {
  buttonColorName: any;
  IncrementFyYear:any;
  getIncrementFyYearList:any = []
  FormYear:any
  ToYear:any
  fileName:any = null;
  fileType:any = null;
  formData:any = new FormData();
  loggedInUserCompanyID: any;
  selectedYear:any;
  companyYears:any []= [];
  loggedInCompanyFiscalyear: any;
  letterHeadUrl:any;
  isDisabled:boolean = false;
  isFileSizeIsInvalid:boolean = false;
  isIncrementLetterCreateContent:any = false
  showBrowseBtn: boolean = false;
  getUploadIncrementPolicyYear:any = []
  isDisabledUploadPolicyBtn:boolean = true;
  isDisabledPolicyLetter:boolean = true;


  constructor(public dialog: MatDialog, private router:Router, private config: Config,
    private httpService: HttpService, private encryptionService: EncryptionService,
    private loadingService: LoaderService, public sharedService: SharedService,
  ) { }

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID'))); 
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
  }

  onClickGoToSetup(operation: any) {
    this.router.navigate(['/home/hrportal/increment', { operation: operation }]);
  }

  ionViewWillEnter() {
    this.getIncrementFyYear();
    }

    getIncrementFyYear() {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "fromYear": null,
        "toYear": null
      }
      this.httpService.callPostService(this.config.getOverallBudgetGrid, request).subscribe((result: any) => {
        this.getIncrementFyYearList = result.data.map((ele: any) => ({
          year: `${ele.fromYear}-${ele.toYear}`,
        }));
  
        // const currentYear = new Date().getFullYear();
        // let yearValue = '';
        // if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
        //   yearValue = `${currentYear}-${currentYear}`;
        // } else {
        //   yearValue = `${currentYear}-${currentYear + 1}`;
        // }

        const currentYear = new Date().getFullYear();
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth(); 
        let yearValue = '';
        if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
          yearValue = `${currentYear}-${currentYear}`;
        } else {
          yearValue = `${currentYear}-${currentYear + 1}`;
          if(this.loggedInCompanyFiscalyear === 'Apr_Mar'){
            if(currentMonth<3){
              yearValue = `${currentYear-1}-${currentYear}`;
            }else{
              yearValue = `${currentYear}-${currentYear + 1}`;
            }
          }
          if(this.loggedInCompanyFiscalyear === 'July_Jun'){
            if(currentMonth<6){
              yearValue = `${currentYear-1}-${currentYear}`;
            }else{
              yearValue = `${currentYear}-${currentYear + 1}`;
            }
          }
          if(this.loggedInCompanyFiscalyear === 'Oct_Sep'){
            if(currentMonth<9){
              yearValue = `${currentYear-1}-${currentYear}`;
            }else{
              yearValue = `${currentYear}-${currentYear + 1}`;
            }
          }
        }

        let selectedYearIndex = this.getIncrementFyYearList.findIndex((ele: any) => ele?.year === yearValue);
        if (selectedYearIndex === -1) {
          selectedYearIndex = 0;
        }
        this.IncrementFyYear = this.getIncrementFyYearList[selectedYearIndex]?.year;
        var test = this.IncrementFyYear?.split('-');
        this.FormYear = test[0];
        this.ToYear = test[1];

      this.getMDApprovedData();
      this.getIncrementPolicy();
      })
    }

    // selectedIncrementInputFYYear(event:any){
    //   const demovalue = event.value.toString();
    //   const selectedYear = demovalue.split('-')
    //   this.FormYear = selectedYear[0];
    //   this.ToYear = selectedYear[1];
    // }

  triggerFileInput() {
    const fileInput:any = document?.getElementById('fileInput') as HTMLInputElement;
    fileInput?.click();
  }

  onFileSelected(event: Event) {
    const inputEvent:any = event.target as HTMLInputElement;
    this.fileName = null;
    this.fileType = null;
    this.formData = new FormData();
    const fileSizeInKB = inputEvent.files[0].size / 1024;
    const fileSizeInMB = fileSizeInKB / 1024;    
    if (!inputEvent.files[0] || inputEvent.files[0].length == 0) {
      return;
    }
    if (inputEvent.files[0].name.includes('csv') && !inputEvent.files[0].name.includes('CSV') && !inputEvent.files[0].name.includes('xlsx') && !inputEvent.files[0].name.includes('XLSX')) {
      window.alert("File format is not supported");
      return;
    }
    if (fileSizeInMB > 10) {
      window.alert("File size is greater than 10MB");
      return;
    }
      if (inputEvent.files[0]) {
        this.fileName = inputEvent.files[0].name;
        this.fileType = inputEvent.files[0].type;
        this.formData = new FormData();
        this.formData.append('file', inputEvent.files[0]);
        this.formData.append('companyId', this.loggedInUserCompanyID);
        this.showBrowseBtn = true;
        this.isDisabledUploadPolicyBtn = false;
        this.isFileSizeIsInvalid = false;
        const url = this.config.uploadFileLocally + `?fileName=${this.fileName}&fileType=${this.fileType}`;
        this.httpService.submitFormService(url, this.formData).subscribe((data: any) => {
          this.letterHeadUrl=data?.data;
        })
      }
}

onClickCancelUploadPolicy(){
  this.showBrowseBtn = false;
  this.isDisabledUploadPolicyBtn = true;
}


onClickUploadPolicy() {
  const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
    disableClose: true,
    height: '25%',
    width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
    data: {
      msg: 'Increment policy successfully uploaded.',
      btn2: 'Done',
      btn2BgColor: this.buttonColorName,
      showSuccessIcon: true,
      showSuccessMessage: false,
      showCloseIcon: false
    },
  });
  dialogRef.afterClosed().subscribe(result => {
    if (result) {
      const payload = {
        "companyId": this.loggedInUserCompanyID,
        "fromYear": this.FormYear.toString(),
        "incrementPolicyFileName": this.fileName,
        "incrementPolicyUrl": this.letterHeadUrl,
        "toYear": this.ToYear.toString(),
      };   
      this.httpService.callPostService(this.config.uploadIncrementPolicy, payload).subscribe((result:any)=>{
        if(result){
          this.showBrowseBtn = false;
          this.isDisabledUploadPolicyBtn = true;
          this.router.navigate(['/home/hrportal/increment', { operation: 'Setup' }]);
        }
      })
    }
  });
}

getDownloadPolicy(){
  const request =  {
    "companyId": this.loggedInUserCompanyID,
    "fromYear": this.FormYear.toString(),
    "toYear": this.ToYear.toString()
  }    
  this.httpService.callPostService(this.config.getIncrementSetupByYear, request).subscribe((result:any)=>{
    const downloadFile:any = result.data;  
   if(downloadFile.incrementPolicyUrl){
    // var fileName:any = downloadFile.incrementPolicyUrl.split(environment.downloadURL)
    // saveAs(downloadFile.incrementPolicyUrl, fileName[1]);
    if(downloadFile.incrementPolicyUrl!=null){
      var fileName = downloadFile.incrementPolicyUrl?.split(environment.downloadURL)
      saveAs(downloadFile.incrementPolicyUrl, fileName[1]); 
    }
  }else{
    console.warn("error");   
  }
  })
}

getMDApprovedData() {
  const request = {
    "companyId": this.loggedInUserCompanyID,
    "fromYear": this.FormYear.toString(),
    "toYear": this.ToYear.toString()
  }
  this.httpService.callPostService(this.config.getIncrementApprovalDataOfCompany, request).subscribe((result: any) => {
    if (result.data?.mdReviewStatus == "Approved") {
      this.isDisabledPolicyLetter = false;
    }
    else if (result.data?.mdReviewStatus == "Rejected") {
      this.isDisabledPolicyLetter = true;
    }
    else {
      this.isDisabledPolicyLetter = true;
    }
  })
}


removeUploadedFile() {
  this.fileName = null;
  this.fileType = null;
  this.letterHeadUrl = null;
  this.selectedYear = null;
  this.formData = new FormData();
  this.showBrowseBtn = false;
  this.isDisabledUploadPolicyBtn = true;
}


getIncrementPolicy(){
  const request =  {
    "companyId": this.loggedInUserCompanyID,
    "fromYear": this.FormYear.toString(),
    "toYear": this.ToYear.toString()
  }    
  this.httpService.callPostService(this.config.getIncrementSetupByYear, request).subscribe((result:any)=>{
    if(result.data.incrementPolicyFileName != null){
      this.fileName = result.data.incrementPolicyFileName;
      this.showBrowseBtn = true;
    }else{
      this.showBrowseBtn = false;
    }

  })
}

onCloseFile(){
  this.showBrowseBtn = false;
}
}
